/* Draft-only presentation: never writes product data. Bundle perfume omission confirmed by merchant 2026-10-15. */
(function () {
  'use strict';
  var ingredientLabel = /^(?:(?:full|complete|key|active|hero|main|star)\s+)?ingredients?(?:\s+list)?(?:\s*[:：–-]\s*|\s*$)/i;
  var nextSection = /^(?:how to (?:use|apply)|directions?(?: for use)?|usage|application|instructions?|benefits?|key benefits?|warnings?|caution|precautions?|important notes?|please note|safety|storage|suitable for|description|what it does|size)(?:\s*[:：–-]\s*|\s*$)/i;
  var instruction = /^(?:for external use|do not\b|avoid\b|keep (?:out|away)|patch test|gently (?:apply|massage|pat)|apply\b|massage\b|rinse\b|use (?:daily|only|with|after|before|on|in|a)|store (?:in|away)|follow (?:with|up)|cleanse\b|allow\b)/i;
  function text(node) { return (node.textContent || '').replace(/\s+/g, ' ').trim(); }
  function markers(root) {
    return Array.prototype.filter.call(root.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div,li'), function (node) {
      return !node.querySelector('h1,h2,h3,h4,h5,h6,p,div,ul,ol,table');
    }).map(function (node) {
      var value = text(node).replace(/^[*•\s]+/, '');
      var ingredient = ingredientLabel.test(value);
      // Multiple sections in one paragraph have no safe structural boundary.
      if (ingredient && /(?:how to use|directions for use|warnings?|caution)\s*[:：]/i.test(value.replace(ingredientLabel, ''))) ingredient = false;
      var bold = node.querySelector('strong,b');
      var heading = /^H[1-6]$/.test(node.tagName) || (bold && text(bold) === value && value.length < 120);
      return { node: node, ingredient: ingredient, inline: ingredient && value.replace(ingredientLabel, '').length > 0, boundary: ingredient || heading || nextSection.test(value) || instruction.test(value) };
    }).filter(function (item) { return item.boundary; });
  }
  function split(source) {
    var description = source.cloneNode(true);
    var found = markers(description);
    var fragments = [];
    // Work backwards so earlier DOM ranges remain valid. Entire nodes and their
    // formatting are moved, including labels, footnotes and component names.
    for (var i = found.length - 1; i >= 0; i -= 1) {
      if (!found[i].ingredient || (i > 0 && found[i - 1].ingredient)) continue;
      var end = i + 1;
      while (found[end] && found[end].ingredient) end += 1;
      var range = document.createRange();
      range.setStartBefore(found[i].node);
      // A labelled inline list belongs to its own paragraph. Do not sweep
      // unlabelled usage or marketing paragraphs following it into Ingredients.
      if (found[i].inline && end === i + 1) range.setEndAfter(found[i].node);
      else if (found[end]) range.setEndBefore(found[end].node);
      else range.setEnd(description, description.childNodes.length);
      var candidate = range.cloneContents();
      var payload = text(candidate).replace(/(?:(?:full|complete|key|active|hero|main|star)\s+)?ingredients?(?:\s+list)?\s*[:：–-]?/gi, '').trim();
      // An ingredient-name subheading may require manual review. Never move
      // just the section title and leave its list behind.
      if (!payload) continue;
      var fragment = range.extractContents();
      if (text(fragment)) fragments.unshift(fragment);
    }
    return { description: description, fragments: fragments };
  }
  function render(source, target) {
    var result = split(source);
    target.replaceChildren();
    var prose = document.createElement('div');
    prose.className = 'bot-separated-description prose max-w-none';
    while (result.description.firstChild) prose.appendChild(result.description.firstChild);
    target.appendChild(prose);
    if (result.fragments.length) {
      var details = document.createElement('details');
      details.className = 'bot-ingredients-accordion';
      var summary = document.createElement('summary');
      summary.className = 'bot-product-reviews__summary';
      summary.innerHTML = '<span class="bot-product-reviews__title">Ingredients</span><span class="bot-product-reviews__summary-end"><svg class="bot-product-reviews__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="m6 9 6 6 6-6" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"></path></svg></span>';
      var body = document.createElement('div');
      body.className = 'bot-ingredients-accordion__body prose max-w-none';
      result.fragments.forEach(function (fragment) { body.appendChild(fragment); });
      details.appendChild(summary);
      details.appendChild(body);
      var reviews = document.querySelector('.bot-product-reviews > .bot-product-reviews__details');
      if (reviews) {
        // Both responsive descriptions render the same source. Keep one shared
        // disclosure beside Reviews, outside either hidden responsive layout.
        if (!reviews.parentElement.querySelector('.bot-ingredients-accordion')) {
          details.classList.add('bot-product-reviews__details');
          reviews.before(details);
        }
      } else target.appendChild(details);
    }
    return result.fragments.length;
  }

  function updateVariantIngredients() {
    var picker = document.querySelector('variant-picker[data-url="/products/glycolic-acid-niacinamide-combo"],variant-picker[data-url="/products/mandelic-acid-body-wash"]');
    var accordion = document.querySelector('#shopify-product-reviews .bot-ingredients-accordion');
    if (!picker || !accordion) return;
    var body = accordion.querySelector('.bot-ingredients-accordion__body');
    if (!body) return;
    var selected = Array.prototype.map.call(picker.querySelectorAll('fieldset'), function (group) {
      var input = group.querySelector('input:checked,select');
      var label = group.querySelector('legend');
      return input && label ? { name: text(label), value: input.value } : null;
    }).filter(Boolean);
    var fragrances = selected.filter(function (option) { return /shower gel|body lotion|fragrance/i.test(option.name); });
    if (!fragrances.length) return;

    // Merchant confirmed both bundle formulas differ only by perfume.
    if (picker.getAttribute('data-url') === '/products/glycolic-acid-niacinamide-combo') {
      var lists = Array.prototype.filter.call(body.querySelectorAll('p'), function (p) {
        return /Aqua \(Water\),/.test(text(p));
      });
      lists.forEach(function (list) {
        var option = fragrances.find(function (item) {
          return /Body Wash/.test(text(list)) ? /shower gel/i.test(item.name) : /body lotion/i.test(item.name);
        });
        if (!option) return;
        if (!list.botOriginalFormula) list.botOriginalFormula = list.innerHTML;
        var holder = document.createElement('div');
        holder.innerHTML = list.botOriginalFormula;
        if (/fragrance free/i.test(option.value)) {
          var walker = document.createTreeWalker(holder, NodeFilter.SHOW_TEXT);
          var node;
          while ((node = walker.nextNode())) {
            node.nodeValue = node.nodeValue.replace(/Parfum \(Fragrance\),\s*/g, '');
          }
        }
        var label = document.createElement('strong');
        label.setAttribute('data-bot-selected-formula', '');
        label.textContent = option.value;
        holder.prepend(document.createElement('br'));
        holder.prepend(label);
        if (list.innerHTML !== holder.innerHTML) list.innerHTML = holder.innerHTML;
      });
      return;
    }

    var hasFree = fragrances.some(function (option) { return /fragrance free/i.test(option.value); });
    var note = body.querySelector('[data-bot-formula-status]');
    var reference = body.querySelector('[data-bot-formula-reference]');
    if (!note) {
      reference = document.createElement('div');
      reference.setAttribute('data-bot-formula-reference', '');
      while (body.firstChild) reference.appendChild(body.firstChild);
      note = document.createElement('p');
      note.setAttribute('data-bot-formula-status', '');
      note.setAttribute('role', 'status');
      var referenceLabel = document.createElement('p');
      referenceLabel.setAttribute('data-bot-formula-label', '');
      referenceLabel.textContent = 'Existing product-level lists — variant not confirmed';
      referenceLabel.style.fontWeight = '700';
      reference.prepend(referenceLabel);
      body.appendChild(note);
      body.appendChild(reference);
    }
    var message = 'Selected: ' + fragrances.map(function (option) { return option.name + ': ' + option.value; }).join(' · ') + '. ';
    message += hasFree
      ? 'The ingredient lists for the fragrance-free options are not yet confirmed. The existing lists contain Parfum (Fragrance) and are not shown as ingredients for your selection.'
      : 'The existing ingredient lists below contain Parfum (Fragrance), but their exact fragrance variants have not yet been confirmed.';
    if (note.textContent !== message) note.textContent = message;
    reference.hidden = hasFree;
  }
  var formulaScheduled = false;
  function scheduleFormulaUpdate() {
    if (formulaScheduled) return;
    formulaScheduled = true;
    window.requestAnimationFrame(function () {
      formulaScheduled = false;
      updateVariantIngredients();
    });
  }
  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-picker')) scheduleFormulaUpdate();
  });
  new MutationObserver(function (records) {
    if (records.some(function (record) {
      return record.type === 'attributes' || Array.prototype.some.call(record.addedNodes, function (node) {
        return node.nodeType === 1 && (node.matches('variant-picker,.bot-ingredients-accordion') || node.querySelector('variant-picker,.bot-ingredients-accordion'));
      });
    })) scheduleFormulaUpdate();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-bot-selected-variant'] });
  scheduleFormulaUpdate();

  window.BotIngredientSections = { split: split, render: render };
})();
